import React, { FC } from "react";
import { MiniChat } from "@zeemee/react-web-chat";
import { useLocation } from "react-router-dom";

export const ReactWebChatMiniChat: FC = () => {
  const location = useLocation();

  if (location.pathname.includes("/chat")) {
    return null;
  }

  return <MiniChat />;
};
